/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleQueryIsActive extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScheduleQueryIsActive");
    }

    getFixupPrototypeFunction() { return ScheduleQueryIsActive.fixupPrototype; }

    static newInstance(model: Partial<ScheduleQueryIsActive>): ScheduleQueryIsActive {
        let obj = Object.assign(new ScheduleQueryIsActive(), model);
        ScheduleQueryIsActive.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleQueryIsActive>): ScheduleQueryIsActive {
        if (!model) return null;
        return ScheduleQueryIsActive.newInstance(<ScheduleQueryIsActive> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleQueryIsActive) {
        if (!obj) return;

        models.ScheduleQueryIsActive.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleQueryIsActive): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleQueryIsActive.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag to represent whether the schedule is active or not
     */
    is_active: Array<boolean>;

}
